module.exports = __webpack_public_path__ + "static/6- Echinacea purpurea-f3172848bd3e08918438a26b9905f286.jpg";